function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * @license
 * Copyright (c) 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */

/**
 * A helper for observing slot changes.
 */
export var SlotObserver = /*#__PURE__*/function () {
  function SlotObserver(slot, callback) {
    var _this = this;

    _classCallCheck(this, SlotObserver);

    /** @type HTMLSlotElement */
    this.slot = slot;
    /** @type Function */

    this.callback = callback;
    /** @type {Node[]} */

    this._storedNodes = [];
    this._connected = false;
    this._scheduled = false;

    this._boundSchedule = function () {
      _this._schedule();
    };

    this.connect();

    this._schedule();
  }
  /**
   * Activates an observer. This method is automatically called when
   * a `SlotObserver` is created. It should only be called to  re-activate
   * an observer that has been deactivated via the `disconnect` method.
   */


  _createClass(SlotObserver, [{
    key: "connect",
    value: function connect() {
      this.slot.addEventListener('slotchange', this._boundSchedule);
      this._connected = true;
    }
    /**
     * Deactivates the observer. After calling this method the observer callback
     * will not be called when changes to slotted nodes occur. The `connect` method
     * may be subsequently called to reactivate the observer.
     */

  }, {
    key: "disconnect",
    value: function disconnect() {
      this.slot.removeEventListener('slotchange', this._boundSchedule);
      this._connected = false;
    }
    /** @private */

  }, {
    key: "_schedule",
    value: function _schedule() {
      var _this2 = this;

      if (!this._scheduled) {
        this._scheduled = true;
        queueMicrotask(function () {
          _this2.flush();
        });
      }
    }
    /**
     * Run the observer callback synchronously.
     */

  }, {
    key: "flush",
    value: function flush() {
      if (!this._connected) {
        return;
      }

      this._scheduled = false;

      this._processNodes();
    }
    /** @private */

  }, {
    key: "_processNodes",
    value: function _processNodes() {
      var _this3 = this;

      var currentNodes = this.slot.assignedNodes({
        flatten: true
      });
      var addedNodes = [];
      var removedNodes = [];
      var movedNodes = [];

      if (currentNodes.length) {
        addedNodes = currentNodes.filter(function (node) {
          return !_this3._storedNodes.includes(node);
        });
      }

      if (this._storedNodes.length) {
        this._storedNodes.forEach(function (node, index) {
          var idx = currentNodes.indexOf(node);

          if (idx === -1) {
            removedNodes.push(node);
          } else if (idx !== index) {
            movedNodes.push(node);
          }
        });
      }

      if (addedNodes.length || removedNodes.length || movedNodes.length) {
        this.callback({
          addedNodes: addedNodes,
          movedNodes: movedNodes,
          removedNodes: removedNodes
        });
      }

      this._storedNodes = currentNodes;
    }
  }]);

  return SlotObserver;
}();